export default {
  COLLECTION_OVERVIEW_BY_FASHIONABILITY:
    'collection-overview-by-fashionability',
  PDF_EXPORT: 'pdf-export',
  PDF_QUALITY_SELECTION: 'pdf-quality-selection',
  STYLE_INTEGRATION: 'style-integration',
  STYLE_DATA_INTEGRATION: 'style-data-integration'
}
